import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import {
  failureaddArithmeticGameSkill,
  successaddArithmeticGameSkill,
} from "./AddArithmeticGameSkillSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { ISkill } from "../../../Pages/Skillstrainer/ISkill";

// add
const AddArithmeticGameSkillApi = (action: PayloadAction<ISkill>) => {
  return api.post("/api/settings/skill-training", action.payload);
};

export function* AddArithmeticGameSkillCall(action: PayloadAction<ISkill>) {
  try {
    const response: AxiosResponse = yield call(
      AddArithmeticGameSkillApi,
      action
    );
    yield put(successaddArithmeticGameSkill(response.data));
  } catch (error) {
    yield put(failureaddArithmeticGameSkill(error));
  }
}
